import React, { useCallback } from 'react';
import Modal from './modal/modalComponent';
import { useGetGenericActions } from 'hooks/useGetGenericActions';
import { genericActionsIds, pageIds } from 'utilities/constants';
import { ModalButtonProps } from './modal/modal.interfaces';
import { useGetPage } from 'hooks/useGetPage';
import { AUTH_LOGIN } from 'utilities/routes';
import {
  BlockerState,
  INavigateBlock,
  useNavigateBlock,
} from 'hooks/useNavigateBlock';
import { useFirebaseSignOut } from '../firebase/hooks';

const NavigateBlockModal: React.FC<INavigateBlock> = ({
  isBlock,
  leaveCallback,
  text,
  title,
}) => {
  const signOutUser = useFirebaseSignOut();
  const {
    handleConfirm: handleContinue,
    handleCancel,
    blocker,
  } = useNavigateBlock(isBlock);

  const { data: genericAction, loading: genericActionLoading } =
    useGetGenericActions({
      locale: 'en',
      genericActionId: [genericActionsIds.CANCEL, genericActionsIds.LEAVE],
    });

  const { data: locale, loading } = useGetPage({
    locale: 'en',
    pageId: pageIds.LEAVE_PAGE_MODAL,
  });

  const sessionExpired = blocker.location?.pathname === AUTH_LOGIN;

  const handleConfirm = useCallback(() => {
    if (sessionExpired) {
      signOutUser();
    }
    leaveCallback && setTimeout(leaveCallback, 300);
    handleContinue();
  }, [handleContinue, leaveCallback, sessionExpired, signOutUser]);

  const Buttons: ModalButtonProps[] = sessionExpired
    ? [
        {
          label: genericAction?.[genericActionsIds.LEAVE]?.leave,
          onClick: handleConfirm,
          testID: 'confirm',
          className: 'desktop:w-[160px] text-sm font-bold  rounded',
        },
      ]
    : [
        {
          label: genericAction?.[genericActionsIds.LEAVE]?.leave,
          onClick: handleConfirm,
          testID: 'confirm',
          className: 'desktop:w-[160px] text-sm font-bold  rounded',
        },
        {
          label: genericAction?.[genericActionsIds.CANCEL]?.cancel,
          onClick: handleCancel,
          type: 'underline',
          testID: 'cancel',
          className: 'text-sm font-bold ',
        },
      ];

  if ((loading && !locale) || (genericActionLoading && !genericAction)) {
    return null;
  }

  return (
    <Modal
      isOpen={blocker.state === BlockerState.BLOCKED}
      onClose={sessionExpired ? handleConfirm : handleCancel}
      buttons={Buttons}
      modalContainerCustomClass="desktop:max-w-[600px] mx-auto"
      titleCustomClass="normal-case  !text-charcoal-gray !text-h3"
      title={title || locale?.title}
      disableMobileGrow
    >
      <p className="text-med-gray font-medium whitespace-pre-wrap">
        {text ?? locale?.description}
      </p>
    </Modal>
  );
};

export default NavigateBlockModal;
